/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3dvcmxkLXJhbmtpbmctc3RhdGlzdGljcy93Y3VwLXJhbmtpbmcvY29tcG9uZW50cy93Y3VwLXJhbmtpbmctZmlsdGVycy93Y3VwLXJhbmtpbmctZmlsdGVycy5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
